import { useSelector } from 'react-redux'
import {
  normalizePlanId,
  planHasFeature,
  getUpgradePath,
  getPlanById,
} from '../Plan.js'

/**
 * usePlan()
 *
 * Returns everything a component needs to know about the current user's plan.
 *
 * Usage:
 *   const { canAccess, currentPlan, upgradeTo, requiresPlan } = usePlan()
 *
 *   canAccess('hair_diagnostics')   → true/false
 *   requiresPlan('hair_diagnostics') → 'care' (the minimum plan needed)
 */
export default function usePlan() {
  // Read plan from Redux — agentData.plan should be 'root' | 'care' | 'pro'
  // Falls back to 'root' if not set or normalizes values like 'Care', 'freemium', or 'premium plan'
  const planId = useSelector((state) =>
    normalizePlanId(state.agentData?.plan ?? 'root'),
  )

  const currentPlan = getPlanById(planId)
  const upgradeTo = getUpgradePath(planId)

  /** Returns true if the current plan includes this feature */
  const canAccess = (featureId) => {
    const result = planHasFeature(planId, featureId)
    // console.log(
    //   '[DEBUG canAccess] planId:',
    //   planId,
    //   '| featureId:',
    //   featureId,
    //   '| result:',
    //   result,
    // )
    return result
  }

  /** Returns the minimum plan id that unlocks this feature, or null if all plans have it */
  const requiresPlan = (featureId) => {
    const allPlanIds = ['root', 'care', 'pro']
    for (const id of allPlanIds) {
      if (planHasFeature(id, featureId)) return id
    }
    return null
  }

  return {
    planId,
    currentPlan,
    upgradeTo,
    canAccess,
    requiresPlan,
  }
}
